module.exports = __webpack_public_path__ + "img/web-install.d0722bce.png";